const RECENTLY_VIEWED_STORAGE_KEY = 'dmm_konchu:recently-viewed';
const RECENTLY_VIEWED_MAX_ITEMS = 20;

function getRecentlyViewedProducts() {
  try {
    const stored = localStorage.getItem(RECENTLY_VIEWED_STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}

function setRecentlyViewedProducts(products) {
  try {
    localStorage.setItem(RECENTLY_VIEWED_STORAGE_KEY, JSON.stringify(products));
  } catch {
    /* localStorage unavailable */
  }
}

function recordRecentlyViewedProduct(product) {
  if (!product?.id || !product?.handle) return;

  const id = String(product.id);
  const handle = String(product.handle);
  let items = getRecentlyViewedProducts().filter((item) => String(item.id) !== id);

  items.unshift({ id, handle });
  items = items.slice(0, RECENTLY_VIEWED_MAX_ITEMS);
  setRecentlyViewedProducts(items);
}

function getHandleFromProductInfo(productInfo) {
  if (productInfo.dataset.productHandle) return productInfo.dataset.productHandle;

  const productUrl = productInfo.dataset.url;
  if (!productUrl) return null;

  const match = productUrl.match(/\/products\/([^/?#]+)/);
  return match ? decodeURIComponent(match[1]) : null;
}

function recordCurrentProductView() {
  const productInfo = document.querySelector('product-info[data-product-id]');
  if (!productInfo) return;

  const handle = getHandleFromProductInfo(productInfo);
  if (!handle) return;

  recordRecentlyViewedProduct({
    id: productInfo.dataset.productId,
    handle,
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', recordCurrentProductView);
} else {
  recordCurrentProductView();
}
